import { CommonModule } from '@angular/common';
import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { ToasterComponent } from '@lib/components/toaster/toaster.component';
import { IconService } from '@lib/services/icon.service';
import { ThemeService } from '@lib/services/theme';
import { filter, Subscription } from 'rxjs';

@Component({
    selector: 'app-root',
    standalone: true,
    imports: [CommonModule, RouterModule, ToasterComponent],
    template: `
        <router-outlet></router-outlet>
        <app-toaster></app-toaster>
    `,
})
export class AppComponent implements OnInit, OnDestroy {
    private readonly _themeService = inject(ThemeService);
    private readonly _router = inject(Router);
    private _routerSubscription: Subscription | null = null;

    constructor(private readonly _iconService: IconService) {}

    ngOnInit(): void {
        this._themeService.init();
        this._setupScrollToTop();
    }

    ngOnDestroy(): void {
        if (this._routerSubscription) {
            this._routerSubscription.unsubscribe();
        }
    }

    private _setupScrollToTop(): void {
        this._routerSubscription = this._router.events
            .pipe(filter((event) => event instanceof NavigationEnd))
            .subscribe(() => {
                window.scrollTo(0, 0);
            });
    }
}
